import { render } from "./ChangeCase.vue?vue&type=template&id=2705075e&scoped=true"
import script from "./ChangeCase.vue?vue&type=script&lang=js"
export * from "./ChangeCase.vue?vue&type=script&lang=js"

import "./ChangeCase.vue?vue&type=style&index=0&id=2705075e&lang=stylus&scoped=true"
script.render = render
script.__scopeId = "data-v-2705075e"

export default script